import { Group } from '@visx/group';
import { LinePath } from '@visx/shape';

function PredictionLineSeries({
    x,
    y,
    historical,
    prediction,
    strokeColor,
    strokeColorPrediction,
    predictionStrokeDasharray = true,
    strokeWidth = '3px',
}) {
    return (
        <Group>
            <LinePath
                x={x}
                y={y}
                data={historical}
                css={`
                    stroke: ${strokeColor};
                    stroke-width: ${strokeWidth};
                    stroke-linejoin: round;
                    stroke-linecap: round;
                `}
            />
            {prediction ? (
                <LinePath
                    x={x}
                    y={y}
                    data={prediction}
                    css={`
                        stroke: ${strokeColorPrediction || strokeColor};
                        stroke-width: ${strokeWidth};
                        stroke-linejoin: round;
                        stroke-linecap: round;
                        ${
                            predictionStrokeDasharray
                                ? `stroke-dasharray: calc(2 * ${strokeWidth});`
                                : ''
                        }
                    `}
                />
            ) : null}
        </Group>
    );
}

export default PredictionLineSeries;
